import { MEDIA_BASE_URL } from "../lib/env";

export const getFullImageUrl = (basePath) => {
    return `${MEDIA_BASE_URL}/${basePath}`;
}